import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { withTheme } from 'react-jss'

import sharedStyles from 'components/shared-style'

const TableAttribute = ({ label, value, editPath, theme }) => {
  const classes = sharedStyles(theme)

  return (
    <div className={classes.tableAttribute}>
      <div className={classes.tableAttributeContent}>
        <strong className={classes.tableAttributeLabel}>{label}</strong>
        <span className={classes.tableAttributeValue}>{value}</span>
      </div>
      {editPath && <Link className={classNames('fal', 'fa-pencil', classes.tableAttributeEdit)} to={editPath} />}
    </div>
  )
}

TableAttribute.propTypes = {
  theme: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  editPath: PropTypes.string,
}

TableAttribute.defaultProps = {
  value: ''
}

export default withTheme(TableAttribute)
